import React, { memo } from 'react';
import PropTypes from 'prop-types';

import createStyle from 'shared-utils/src/createStyle';
import makeClassName from 'shared-utils/src/makeClassName';
import isString from 'shared-utils/src/checkVarType/isString';

import GridItem from '../GridItem';

import styles, { mainCls } from './styles';

const useStyles = createStyle(styles);

const um = (x) => {
	return x[x.length - 1] === '%' || (x === 'auto') || (isString(x) && x.indexOf('calc') === 0)
		? x
		: `${x}px`;
}

function SkeletonLine({
  mt,
  mr,
  mb,
  ml,
  width,
  height,
  push,
  circle,
  round,
  className,
}) {
  const cls = useStyles();
  const propsStyle = {
    marginTop: mt && um(mt),
    marginRight: mr && um(mr),
    marginBottom: mb && um(mb),
    marginLeft: ml && um(ml),
    width: width && um(width),
    height: height && um(height),
    lineHeight: height && um(height),
  };

  let bRadius = 'b-r--m';
  if (circle) {
    bRadius = 'b-r--pill'; 
  }
  if (round) {
    bRadius = 'b-r--100'; 
  }

  const cssCls = makeClassName([
    cls[mainCls],
    className,
    bRadius,
  ]);
  return (
    <div
      className={cssCls}
      style={propsStyle}
    />
  );
};
SkeletonLine.propTypes = {
  mt: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  mr: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  mb: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  ml: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  push: PropTypes.string,
  circle: PropTypes.bool,
  className: PropTypes.string,
};
SkeletonLine.defaultProps = {
  mt: null,
  mr: null,
  mb: null,
  ml: null,
  width: '100%',
  height: null,
  push: null,
  circle: false,
  className: null,
};
export default memo(SkeletonLine);